export default "__VITE_ASSET__0c61SiNe__"